#import "~/graphql/fragments/sections/global-content/video.graphql"
#import "~/graphql/fragments/sections/global-content/quote.graphql"
#import "~/graphql/fragments/sections/global-content/dossierCard.graphql"

fragment streamGlobalEntriesField on EntryInterface {
    ... on globalVideo_Entry {
        ... globalVideoSection
    }
    ... on globalQuote_Entry {
        ... globalQuoteSection
    }
    ... on globalDossierCard_Entry {
        ... globalDossierCardSection
    }
}
